import api from '../../../api/index';
import shopkeeperAppApi from '../../../api/shopkeeperAppApi';

export default {
  updateSenha({ rootGetters }, data) {
    return api.post('gerente/update-senha', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listarLojistas({ rootGetters }, id) {
    return api.get('gerente/listar-lojistas/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listarRecomendacoesAll({ rootGetters }) {
    return api.get('gerente/listar-recomendacoes-todas', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  listarRecomendacoes({ rootGetters }, id) {
    return api.get('gerente/listar-recomendacoes/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  salvarRecomendacao({ rootGetters }, data) {
    return api.post('gerente/salvar-recomendacoes', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  atualizarRecomendacao({ rootGetters }, data) {
    return api.post('gerente/atualizar-recomendacoes', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarPedidos({ rootGetters }, data) {
    return shopkeeperAppApi.post('payment/gerente/listar-pedidos', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarGerente({}, id) {
    return api.get('gerente/listar-gerente/'+id);
  },
  buscarGerenteId({ rootGetters }, id) {
    return api.get('gerente/listar-gerente-id/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarLinksId({ rootGetters }, id) {
    return shopkeeperAppApi.get('listar-links/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  vincularGerente({ rootGetters }, data) {
    return api.post('gerente/vincular-gerente', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  simularAcesso({ rootGetters }, data) {
    return api.post('admin/simular-acesso-gerente', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
